import script from "./PatientRecruitmentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientRecruitmentForm.vue?vue&type=script&setup=true&lang=js"

import "./PatientRecruitmentForm.vue?vue&type=style&index=0&id=64b6a0ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64b6a0ae"]])

export default __exports__